var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M2.81 0A2.805 2.805 0 000 2.799V19.2A2.805 2.805 0 002.81 22h8.201v-7.582H8.316V11h2.695V8.603c0-.723.12-2.07 1.014-3.086.99-1.124 2.315-1.434 3.053-1.434h2.845v3.499h-2.108c-.246-.023-.737.092-.737.734V11h3.501l-1.394 3.418h-2.107V22h4.111A2.805 2.805 0 0022 19.201V2.8A2.805 2.805 0 0019.19 0H2.81z"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 22 22","role":"img"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
